export const DATE_PICKER_TYPES = {
	START: 'start',
	END: 'end',
} as const;
